__turbopack_context__.v({
  "bannerMediathek": "BoardSectionTileRegional4-module-scss-module__dmlI8q__bannerMediathek",
  "bannerSection": "BoardSectionTileRegional4-module-scss-module__dmlI8q__bannerSection",
  "externalLink": "BoardSectionTileRegional4-module-scss-module__dmlI8q__externalLink",
  "videoSection": "BoardSectionTileRegional4-module-scss-module__dmlI8q__videoSection",
  "videoSectionTitle": "BoardSectionTileRegional4-module-scss-module__dmlI8q__videoSectionTitle",
});
